import React from "react";
import { AuthLayout } from "../layouts/AuthLayout";
import { AccountBlocked } from "../pure/AccountBlocked";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var AccountBlockedContainer = function AccountBlockedContainer() {
  return ___EmotionJSX(AuthLayout, null, ___EmotionJSX(AccountBlocked, null));
};